import React, {useEffect} from "react";
import NavXCSI from "../layout/respnsivenavigation/nav-xsci";
import FooterXsci from "../layout/footer/footer-xsci";
import CenteredPageContainer from "../common/centeredcontainer/centered-page-container";
import templateStyles from "./contact-template.module.css";
import {useLocation} from "react-router-dom";


const  PrivacyPolicy = () => {

    const location = useLocation();

    useEffect(() => {
        // Change the background color when this page is loaded
        document.body.style.backgroundColor = 'white';

        // Cleanup the effect when leaving this page (optional)
        return () => {
            document.body.style.backgroundColor = ''; // Reset background color when leaving
        };
    }, [location]);

    const privacyStyle = {
        color: 'black',
        fontFamily: 'Arial, sans-serif', // You can adjust the font as needed
        lineHeight: '1.6', // Increase line height for readability
        textAlign: 'left' as 'left', // Ensure textAlign is explicitly typed
    };

    return (
        <>
            <NavXCSI/> {/* Navigation outside of the main container */}

            {/* Using the new CenteredPageContainer */}
            <CenteredPageContainer component={() => (
               <>
                   <div className={templateStyles.privacy_container} style={privacyStyle}>
                       <h1>Your Privacy Matters to Us</h1>
                       <p style={{marginTop:"40px"}}>
                           We respect your privacy and are committed to protecting the personal
                           information you provide through our website. This privacy statement
                           outlines how we collect, use, and protect your data when you submit a
                           contact form or interact with us on our site.
                       </p>
                       <h4 style={{marginTop:"40px"}}>1. Information We Collect:</h4>
                       <p>
                           When you contact us through our form, we may collect personal
                           information such as your name, email address, phone number, and company
                           name (if applicable). Any other details you provide in the message field,
                           such as project details or inquiries, are also collected to assist with
                           your request.
                       </p>
                       <h4 style={{marginTop:"40px"}}>2. How We Use Your Information:</h4>
                       <p>
                           The personal information you provide will only be used to respond to
                           your inquiry, communicate with you about our services, or address any
                           questions or concerns you have. We may also use your information to send
                           you relevant updates, promotional materials, or newsletters if you opt-in
                           to such communications (you can unsubscribe at any time).
                       </p>
                       <h4 style={{marginTop:"40px"}}>3. Data Security:</h4>
                       <p>
                           We take reasonable measures to protect your personal information from
                           unauthorized access, disclosure, alteration, and destruction. All data
                           submitted through the contact form is stored securely and will not be
                           shared with third parties without your explicit consent, except as required
                           by law.
                       </p>
                       <h4 style={{marginTop:"40px"}}>4. Data Retention:</h4>
                       <p>
                           Your personal data will only be kept for as long as necessary to fulfill
                           the purpose for which it was collected (e.g., responding to your inquiry
                           or complying with legal obligations). If you no longer wish for us to
                           retain your information, you can request its deletion by contacting us.
                       </p>
                       <h4 style={{marginTop:"40px"}}>5. Your Rights:</h4>
                       <p>
                           You have the right to access, correct, or delete the personal information
                           we hold about you. If you're in a jurisdiction with data protection laws
                           (e.g., GDPR), you have additional rights, such as the right to withdraw
                           consent or object to processing.
                       </p>
                       <h4 style={{marginTop:"40px"}}>6. Third-Party Links:</h4>
                       <p>
                           Our contact page may contain links to third-party websites. We are not
                           responsible for the privacy practices or content of those sites. We
                           encourage you to review their privacy policies.
                       </p>
                       <h4 style={{marginTop:"40px"}}>7. Changes to This Privacy Statement:</h4>
                       <p style={{textAlign:"left"}}>
                           We may update this privacy statement from time to time. Any changes will
                           be posted on this page with an updated date. We encourage you to review
                           this statement periodically to stay informed about how we protect your
                           information.
                       </p>
                       <h4 style={{marginTop:"40px"}}>8. Contact Us:</h4>
                       <p>
                           If you have any questions or concerns about our privacy practices, or if
                           you would like to exercise any of your rights, please contact us at
                           info@xsci.ca or 514-512-6208.
                       </p>
                   </div>
               </>

            )} />

            <FooterXsci/> {/* Footer outside of the main container */}
        </>
    );
};

export default PrivacyPolicy;
